module.exports = __webpack_public_path__ + "static/media/workfolio-blue.e6433c4f.png";